<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormDriedCookingProcessCheck
      :DriedCookingProcessCheck="editDriedCookingProcessCheck"
      :isSaving="isSaving"
      @save="save"
      @cancel="$router.push({name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormDriedCookingProcessCheck from '../components/FormDriedCookingProcessCheck.vue';
import checklist from './checklist';
import formatting from '../mixins/formatting';
import stockItem from './stockItem';

export default {
  components: {
    FormDriedCookingProcessCheck,
  },
  name: 'EditDriedCookingProcessCheck',
  module: 'DriedCookingProcessCheck',
  mixins: [checklist, formatting, loading, stockItem],
  data() {
    return {
      /**
      * Get/Set editing DriedCookingProcessCheck. Default to {}.
      */
      editDriedCookingProcessCheck: {},
      /**
       * Query Id for DriedCookingProcessCheck
       */
      editDriedCookingProcessCheckId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('driedCookingProcessChecks', ['driedCookingProcessChecks', 'driedCookingProcessCheck']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.editDriedCookingProcessCheckId) {
        return 'edit';
      }
      return 'add';
    },
  },
  async mounted() {
    this.$on('stockItem.loaded', (item) => {
      if (this.mode === 'add') {
        this.editDriedCookingProcessCheck.stockItemId = item.id;
        this.editDriedCookingProcessCheck.farm = item.deliveryNote.farm.id;
        this.editDriedCookingProcessCheck.date = this.formatDate(item.productionDate);
        // eslint-disable-next-line max-len
        this.editDriedCookingProcessCheck.receivingDate = this.formatDate(item.deliveryNote.receivingDate);
        this.$log.info('Prepopulation completed');
        this.$forceUpdate();
      } else {
        this.$log.info('No prepopulation required');
      }
    });
    this.isLoading = true;
    if (this.mode === 'edit') {
      await this.LOAD_driedCookingProcessCheck(this.editDriedCookingProcessCheckId);
      // eslint-disable-next-line prefer-destructuring
      this.editDriedCookingProcessCheck = this.driedCookingProcessCheck;
    }
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('driedCookingProcessChecks', ['LOAD_driedCookingProcessCheck', 'CREATE_driedCookingProcessCheck', 'UPDATE_driedCookingProcessCheck']),
    /** Method used to save the item
     */
    async save(driedCookingProcessCheck) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_driedCookingProcessCheck(driedCookingProcessCheck);
      } else {
        await this.UPDATE_driedCookingProcessCheck(driedCookingProcessCheck);
      }
      this.isSaving = false;
      this.$router.push({ name: 'processing-ListFactoryItem' });
    },
  },
};
</script>

<docs>
# EditDriedCookingProcessCheck example

'''js
<EditDriedCookingProcessCheck :DriedCookingProcessCheck="DriedCookingProcessCheck" />
'''
</docs>
